export const MARKETPLACE_GWT = 'MARKETPLACE_GWT';
export const MARKETPLACE_GWT_ID = 'MARKETPLACE_GWT_ID';
export const MARKETPLACE_DEV_CONTEXT = 'MARKETPLACE_DEV_CONTEXT';
export const MARKETPLACE_DEV_DEACTIVATED = 'MARKETPLACE_DEV_DEACTIVATED';
export const MARKETPLACE_CODE_CHALLENGE = 'MARKETPLACE_CODE_CHALLENGE';
export const MARKETPLACE_OAUTH2_STATE = 'MARKETPLACE_OAUTH2_STATE';
export const REDIRECT_URL = 'developer/sign-in/redirect';
export const MARKETPLACE_ADMIN_CONTEXT = 'MARKETPLACE_ADMIN_CONTEXT';
